<template>
  <div>
    <center v-if="tiempo">
      <br />
      <br />
      <Circle9 style="margin-bottom: 8px"></Circle9>
      <small>Cargando Datos ...</small>
      <br />
      <br />
    </center>
    <el-table
      :default-sort="{ prop: 'nombre', order: 'ascending' }"
      element-loading-text="Esto puede tardar varios minutos, Espere Por Favor ..."
      element-loading-background="rgba(255, 255, 255)"
      border
      v-else
      :cell-class-name="pintar"
      row-class-name="rowDashboard"
      header-cell-class-name="header"
      :data="data"
      style="width: 100%; font-size: 12px;"
    >
      <el-table-column align="center" label="GERENCIAS GENERALES">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div style="padding-left: 45px">
              <el-table
                border
                :default-sort="{ prop: 'nombre', order: 'ascending' }"
                :cell-class-name="pintar_gerencias"
                row-class-name="rowDashboard"
                header-cell-class-name="header-blue-light-2"
                :data="props.row.gerencias"
                style="width: 100%; font-size: 12px;"
              >
                <el-table-column align="center" label="GERENCIAS">
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <div style="padding-left: 45px">
                        <el-table
                          :default-sort="{ prop: 'nombre', order: 'ascending' }"
                          border
                          :cell-class-name="pintar_superintendencia"
                          row-class-name="rowDashboard"
                          header-cell-class-name="header-orange"
                          :data="props.row.superintendencias"
                          style="width: 100%; font-size: 12px;"
                        >
                          <el-table-column
                            align="center"
                            label="SUPERINTENDENCIAS"
                          >
                            <el-table-column type="expand">
                              <template slot-scope="scope">
                                <div style="padding-left: 45px">
                                  <el-table
                                    :default-sort="{
                                      prop: 'nombre',
                                      order: 'ascending',
                                    }"
                                    border
                                    :cell-class-name="pintar_areas"
                                    row-class-name="rowDashboard"
                                    header-cell-class-name="header-blue"
                                    :data="scope.row.areas"
                                    style="width: 100%; font-size: 12px;"
                                  >
                                    <el-table-column
                                      align="center"
                                      label="AREAS"
                                    >
                                      <el-table-column type="expand">
                                        <template slot-scope="props">
                                          <div style="padding-left: 45px">
                                            <el-table
                                              :default-sort="{
                                                prop: 'nombre',
                                                order: 'ascending',
                                              }"
                                              border
                                              :cell-class-name="pintar_subareas"
                                              row-class-name="rowDashboard"
                                              header-cell-class-name="header-blue-light"
                                              :data="props.row.subareas"
                                              style="width: 100%; font-size: 12px;"
                                            >
                                              <el-table-column
                                                align="center"
                                                label="SUB-AREAS"
                                              >
                                                <el-table-column
                                                  sortable
                                                  prop="nombre"
                                                  label="Nombre"
                                                >
                                                  <template slot-scope="scope">
                                                    <b>
                                                      <span
                                                        class="font-table"
                                                        >{{
                                                          scope.row.nombre
                                                        }}</span
                                                      >
                                                    </b>
                                                  </template>
                                                </el-table-column>
                                                <el-table-column
                                                  width="170"
                                                  align="center"
                                                  label="TOTAL INVENTARIOS"
                                                >
                                                  <template slot-scope="scope">
                                                    <el-button
                                                      v-if="scope.row"
                                                      :disabled="
                                                        scope.row.contratos
                                                          .length === 0
                                                      "
                                                      style="width: 100%"
                                                      plain
                                                      @click="
                                                        openDialogContrato(
                                                          scope.row.contratos
                                                        )
                                                      "
                                                    >
                                                      <b>
                                                        <span
                                                          class="font-table"
                                                          >{{
                                                            total(
                                                              scope.row
                                                                .contratos
                                                            )
                                                          }}</span
                                                        >
                                                      </b>
                                                    </el-button>
                                                  </template>
                                                </el-table-column>
                                                <el-table-column
                                                  width="120"
                                                  align="center"
                                                  label="APROBADOS"
                                                >
                                                  <template slot-scope="scope">
                                                    <el-button
                                                      v-if="scope.row"
                                                      :disabled="
                                                        findAprobados(
                                                          scope.row.contratos
                                                        ).length === 0
                                                      "
                                                      style="width: 100%"
                                                      plain
                                                      @click="
                                                        openDialogContrato(
                                                          findAprobados(
                                                            scope.row.contratos
                                                          )
                                                        )
                                                      "
                                                    >
                                                      <b>
                                                        <span
                                                          class="font-table"
                                                          >{{
                                                            findAprobados(
                                                              scope.row
                                                                .contratos
                                                            ).length
                                                          }}</span
                                                        >
                                                      </b>
                                                    </el-button>
                                                  </template>
                                                </el-table-column>
                                                <el-table-column
                                                  width="120"
                                                  align="center"
                                                  label="BORRADOR"
                                                >
                                                  <template slot-scope="scope">
                                                    <el-button
                                                      v-if="scope.row"
                                                      :disabled="
                                                        findBorrador(
                                                          scope.row.contratos
                                                        ).length === 0
                                                      "
                                                      style="width: 100%"
                                                      plain
                                                      @click="
                                                        openDialogContrato(
                                                          findBorrador(
                                                            scope.row.contratos
                                                          )
                                                        )
                                                      "
                                                    >
                                                      <b>
                                                        <span
                                                          class="font-table"
                                                          >{{
                                                            findBorrador(
                                                              scope.row
                                                                .contratos
                                                            ).length
                                                          }}</span
                                                        >
                                                      </b>
                                                    </el-button>
                                                  </template>
                                                </el-table-column>
                                                <el-table-column
                                                  width="120"
                                                  align="center"
                                                  label="NO INICIADOS"
                                                >
                                                  <template slot-scope="scope">
                                                    <el-button
                                                      v-if="scope.row"
                                                      :disabled="
                                                        findNoiniciados(
                                                          scope.row.contratos
                                                        ).length === 0
                                                      "
                                                      style="width: 100%"
                                                      plain
                                                      @click="
                                                        openDialogContrato(
                                                          findNoiniciados(
                                                            scope.row.contratos
                                                          )
                                                        )
                                                      "
                                                    >
                                                      <b>
                                                        <span
                                                          class="font-table"
                                                          >{{
                                                            findNoiniciados(
                                                              scope.row
                                                                .contratos
                                                            ).length
                                                          }}</span
                                                        >
                                                      </b>
                                                    </el-button>
                                                  </template>
                                                </el-table-column>
                                                <el-table-column
                                                  width="120"
                                                  align="center"
                                                  label="REVISIÓN"
                                                >
                                                  <template slot-scope="scope">
                                                    <el-button
                                                      v-if="scope.row"
                                                      :disabled="
                                                        findRevision(
                                                          scope.row.contratos
                                                        ).length === 0
                                                      "
                                                      style="width: 100%"
                                                      plain
                                                      @click="
                                                        openDialogContrato(
                                                          findRevision(
                                                            scope.row.contratos
                                                          )
                                                        )
                                                      "
                                                    >
                                                      <b>
                                                        <span
                                                          class="font-table"
                                                          >{{
                                                            findRevision(
                                                              scope.row
                                                                .contratos
                                                            ).length
                                                          }}</span
                                                        >
                                                      </b>
                                                    </el-button>
                                                  </template>
                                                </el-table-column>
                                                <el-table-column
                                                  align="center"
                                                  label="N° de Riesgos en Revisión"
                                                  width="200"
                                                >
                                                  <template slot-scope="scope">
                                                    <el-button
                                                      v-if="scope.row"
                                                      :disabled="
                                                        scope.row.riesgos
                                                          .length === 0
                                                      "
                                                      style="width: 100%"
                                                      plain
                                                      @click="
                                                        openDialogRiesgos(
                                                          scope.row.riesgos
                                                        )
                                                      "
                                                    >
                                                      <b>
                                                        <span
                                                          class="font-table"
                                                          >{{
                                                            scope.row.riesgos
                                                              .length
                                                          }}</span
                                                        >
                                                      </b>
                                                    </el-button>
                                                  </template>
                                                </el-table-column>
                                                <el-table-column
                                                  align="center"
                                                  label="N° Riesgos Pendientes de revisión con más de 10 dias"
                                                >
                                                  <template slot-scope="scope">
                                                    <el-button
                                                      v-if="scope.row"
                                                      :disabled="
                                                        mayoresdies(
                                                          scope.row.riesgos
                                                        ).length === 0
                                                      "
                                                      style="width: 100%"
                                                      plain
                                                      @click="
                                                        openDialogRiesgos(
                                                          mayoresdies(
                                                            scope.row.riesgos
                                                          )
                                                        )
                                                      "
                                                    >
                                                      <b>
                                                        <span
                                                          class="font-table"
                                                          >{{
                                                            mayoresdies(
                                                              scope.row.riesgos
                                                            ).length
                                                          }}</span
                                                        >
                                                      </b>
                                                    </el-button>
                                                  </template>
                                                </el-table-column>
                                                <el-table-column
                                                  align="center"
                                                  label="Tiempo promedio de retraso en riesgos con más de 10 días."
                                                >
                                                  <template slot-scope="scope">
                                                    <b>
                                                      <span
                                                        class="font-table"
                                                        >{{
                                                          promediodias(
                                                            scope.row.riesgos
                                                          )
                                                        }}</span
                                                      >
                                                    </b>
                                                  </template>
                                                </el-table-column>
                                              </el-table-column>
                                            </el-table>
                                          </div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        sortable
                                        prop="nombre"
                                        label="Nombre"
                                      >
                                        <template slot-scope="scope">
                                          <b>
                                            <span class="font-table">{{
                                              scope.row.nombre
                                            }}</span>
                                          </b>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        width="170"
                                        align="center"
                                        label="TOTAL INVENTARIOS"
                                      >
                                        <template slot-scope="scope">
                                          <el-button
                                            v-if="scope.row"
                                            :disabled="
                                              scope.row.contratos.length === 0
                                            "
                                            style="width: 100%"
                                            plain
                                            @click="
                                              openDialogContrato(
                                                scope.row.contratos
                                              )
                                            "
                                          >
                                            <b>
                                              <span class="font-table">{{
                                                total(scope.row.contratos)
                                              }}</span>
                                            </b>
                                          </el-button>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        width="120"
                                        align="center"
                                        label="APROBADOS"
                                      >
                                        <template slot-scope="scope">
                                          <el-button
                                            v-if="scope.row"
                                            :disabled="
                                              findAprobados(scope.row.contratos)
                                                .length === 0
                                            "
                                            style="width: 100%"
                                            plain
                                            @click="
                                              openDialogContrato(
                                                findAprobados(
                                                  scope.row.contratos
                                                )
                                              )
                                            "
                                          >
                                            <b>
                                              <span class="font-table">{{
                                                findAprobados(
                                                  scope.row.contratos
                                                ).length
                                              }}</span>
                                            </b>
                                          </el-button>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        width="120"
                                        align="center"
                                        label="BORRADOR"
                                      >
                                        <template slot-scope="scope">
                                          <el-button
                                            v-if="scope.row"
                                            :disabled="
                                              findBorrador(scope.row.contratos)
                                                .length === 0
                                            "
                                            style="width: 100%"
                                            plain
                                            @click="
                                              openDialogContrato(
                                                findBorrador(
                                                  scope.row.contratos
                                                )
                                              )
                                            "
                                          >
                                            <b>
                                              <span class="font-table">{{
                                                findBorrador(
                                                  scope.row.contratos
                                                ).length
                                              }}</span>
                                            </b>
                                          </el-button>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        width="120"
                                        align="center"
                                        label="NO INICIADOS"
                                      >
                                        <template slot-scope="scope">
                                          <el-button
                                            v-if="scope.row"
                                            :disabled="
                                              findNoiniciados(
                                                scope.row.contratos
                                              ).length === 0
                                            "
                                            style="width: 100%"
                                            plain
                                            @click="
                                              openDialogContrato(
                                                findNoiniciados(
                                                  scope.row.contratos
                                                )
                                              )
                                            "
                                          >
                                            <b>
                                              <span class="font-table">{{
                                                findNoiniciados(
                                                  scope.row.contratos
                                                ).length
                                              }}</span>
                                            </b>
                                          </el-button>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        width="120"
                                        align="center"
                                        label="REVISIÓN"
                                      >
                                        <template slot-scope="scope">
                                          <el-button
                                            v-if="scope.row"
                                            :disabled="
                                              findRevision(scope.row.contratos)
                                                .length === 0
                                            "
                                            style="width: 100%"
                                            plain
                                            @click="
                                              openDialogContrato(
                                                findRevision(
                                                  scope.row.contratos
                                                )
                                              )
                                            "
                                          >
                                            <b>
                                              <span class="font-table">{{
                                                findRevision(
                                                  scope.row.contratos
                                                ).length
                                              }}</span>
                                            </b>
                                          </el-button>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        align="center"
                                        label="N° de Riesgos en Revisión"
                                        width="200"
                                      >
                                        <template slot-scope="scope">
                                          <el-button
                                            v-if="scope.row"
                                            :disabled="
                                              scope.row.riesgos.length === 0
                                            "
                                            style="width: 100%"
                                            plain
                                            @click="
                                              openDialogRiesgos(
                                                scope.row.riesgos
                                              )
                                            "
                                          >
                                            <b>
                                              <span class="font-table">{{
                                                scope.row.riesgos.length
                                              }}</span>
                                            </b>
                                          </el-button>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        align="center"
                                        label="N° Riesgos Pendientes de revisión con más de 10 dias"
                                      >
                                        <template slot-scope="scope">
                                          <el-button
                                            v-if="scope.row"
                                            :disabled="
                                              mayoresdies(scope.row.riesgos)
                                                .length === 0
                                            "
                                            style="width: 100%"
                                            plain
                                            @click="
                                              openDialogRiesgos(
                                                mayoresdies(scope.row.riesgos)
                                              )
                                            "
                                          >
                                            <b>
                                              <span class="font-table">{{
                                                mayoresdies(scope.row.riesgos)
                                                  .length
                                              }}</span>
                                            </b>
                                          </el-button>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        align="center"
                                        label="Tiempo promedio de retraso en riesgos con más de 10 días."
                                      >
                                        <template slot-scope="scope">
                                          <b>
                                            <span class="font-table">{{
                                              promediodias(scope.row.riesgos)
                                            }}</span>
                                          </b>
                                        </template>
                                      </el-table-column>
                                    </el-table-column>
                                  </el-table>
                                </div>
                              </template>
                            </el-table-column>
                            <el-table-column
                              sortable
                              prop="nombre"
                              label="Nombre"
                            >
                              <template slot-scope="scope">
                                <b>
                                  <span class="font-table">{{
                                    scope.row.nombre
                                  }}</span>
                                </b>
                              </template>
                            </el-table-column>
                            <el-table-column
                              width="170"
                              align="center"
                              label="TOTAL INVENTARIOS"
                            >
                              <template slot-scope="scope">
                                <el-button
                                  v-if="scope.row"
                                  :disabled="scope.row.contratos.length === 0"
                                  style="width: 100%"
                                  plain
                                  @click="
                                    openDialogContrato(scope.row.contratos)
                                  "
                                >
                                  <b>
                                    <span class="font-table">{{
                                      total(scope.row.contratos)
                                    }}</span>
                                  </b>
                                </el-button>
                              </template>
                            </el-table-column>
                            <el-table-column
                              width="120"
                              align="center"
                              label="APROBADOS"
                            >
                              <template slot-scope="scope">
                                <el-button
                                  v-if="scope.row"
                                  :disabled="
                                    findAprobados(scope.row.contratos)
                                      .length === 0
                                  "
                                  style="width: 100%"
                                  plain
                                  @click="
                                    openDialogContrato(
                                      findAprobados(scope.row.contratos)
                                    )
                                  "
                                >
                                  <b>
                                    <span class="font-table">{{
                                      findAprobados(scope.row.contratos).length
                                    }}</span>
                                  </b>
                                </el-button>
                              </template>
                            </el-table-column>
                            <el-table-column
                              width="120"
                              align="center"
                              label="BORRADOR"
                            >
                              <template slot-scope="scope">
                                <el-button
                                  v-if="scope.row"
                                  :disabled="
                                    findBorrador(scope.row.contratos).length ===
                                    0
                                  "
                                  style="width: 100%"
                                  plain
                                  @click="
                                    openDialogContrato(
                                      findBorrador(scope.row.contratos)
                                    )
                                  "
                                >
                                  <b>
                                    <span class="font-table">{{
                                      findBorrador(scope.row.contratos).length
                                    }}</span>
                                  </b>
                                </el-button>
                              </template>
                            </el-table-column>
                            <el-table-column
                              width="120"
                              align="center"
                              label="NO INICIADOS"
                            >
                              <template slot-scope="scope">
                                <el-button
                                  v-if="scope.row"
                                  :disabled="
                                    findNoiniciados(scope.row.contratos)
                                      .length === 0
                                  "
                                  style="width: 100%"
                                  plain
                                  @click="
                                    openDialogContrato(
                                      findNoiniciados(scope.row.contratos)
                                    )
                                  "
                                >
                                  <b>
                                    <span class="font-table">{{
                                      findNoiniciados(scope.row.contratos)
                                        .length
                                    }}</span>
                                  </b>
                                </el-button>
                              </template>
                            </el-table-column>
                            <el-table-column
                              width="120"
                              align="center"
                              label="REVISIÓN"
                            >
                              <template slot-scope="scope">
                                <el-button
                                  v-if="scope.row"
                                  :disabled="
                                    findRevision(scope.row.contratos).length ===
                                    0
                                  "
                                  style="width: 100%"
                                  plain
                                  @click="
                                    openDialogContrato(
                                      findRevision(scope.row.contratos)
                                    )
                                  "
                                >
                                  <b>
                                    <span class="font-table">{{
                                      findRevision(scope.row.contratos).length
                                    }}</span>
                                  </b>
                                </el-button>
                              </template>
                            </el-table-column>
                            <el-table-column
                              align="center"
                              label="N° de Riesgos en Revisión"
                              width="200"
                            >
                              <template slot-scope="scope">
                                <el-button
                                  v-if="scope.row"
                                  :disabled="scope.row.riesgos.length === 0"
                                  style="width: 100%"
                                  plain
                                  @click="openDialogRiesgos(scope.row.riesgos)"
                                >
                                  <b>
                                    <span class="font-table">{{
                                      scope.row.riesgos.length
                                    }}</span>
                                  </b>
                                </el-button>
                              </template>
                            </el-table-column>
                            <el-table-column
                              align="center"
                              label="N° Riesgos Pendientes de revisión con más de 10 dias"
                            >
                              <template slot-scope="scope">
                                <el-button
                                  v-if="scope.row"
                                  :disabled="
                                    mayoresdies(scope.row.riesgos).length === 0
                                  "
                                  style="width: 100%"
                                  plain
                                  @click="
                                    openDialogRiesgos(
                                      mayoresdies(scope.row.riesgos)
                                    )
                                  "
                                >
                                  <b>
                                    <span class="font-table">{{
                                      mayoresdies(scope.row.riesgos).length
                                    }}</span>
                                  </b>
                                </el-button>
                              </template>
                            </el-table-column>
                            <el-table-column
                              align="center"
                              label="Tiempo promedio de retraso en riesgos con más de 10 días."
                            >
                              <template slot-scope="scope">
                                <b>
                                  <span class="font-table">{{
                                    promediodias(scope.row.riesgos)
                                  }}</span>
                                </b>
                              </template>
                            </el-table-column>
                          </el-table-column>
                        </el-table>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column sortable prop="nombre" label="Nombre">
                    <template slot-scope="scope">
                      <b>
                        <span class="font-table">{{ scope.row.nombre }}</span>
                      </b>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="170"
                    align="center"
                    label="TOTAL INVENTARIOS"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-if="scope.row"
                        :disabled="scope.row.contratos.length === 0"
                        style="width: 100%"
                        plain
                        @click="openDialogContrato(scope.row.contratos)"
                      >
                        <b>
                          <span class="font-table">{{
                            total(scope.row.contratos)
                          }}</span>
                        </b>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" align="center" label="APROBADOS">
                    <template slot-scope="scope">
                      <el-button
                        v-if="scope.row"
                        :disabled="
                          findAprobados(scope.row.contratos).length === 0
                        "
                        style="width: 100%"
                        plain
                        @click="
                          openDialogContrato(findAprobados(scope.row.contratos))
                        "
                      >
                        <b>
                          <span class="font-table">{{
                            findAprobados(scope.row.contratos).length
                          }}</span>
                        </b>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" align="center" label="BORRADOR">
                    <template slot-scope="scope">
                      <el-button
                        v-if="scope.row"
                        :disabled="
                          findBorrador(scope.row.contratos).length === 0
                        "
                        style="width: 100%"
                        plain
                        @click="
                          openDialogContrato(findBorrador(scope.row.contratos))
                        "
                      >
                        <b>
                          <span class="font-table">{{
                            findBorrador(scope.row.contratos).length
                          }}</span>
                        </b>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    label="NO INICIADOS"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-if="scope.row"
                        :disabled="
                          findNoiniciados(scope.row.contratos).length === 0
                        "
                        style="width: 100%"
                        plain
                        @click="
                          openDialogContrato(
                            findNoiniciados(scope.row.contratos)
                          )
                        "
                      >
                        <b>
                          <span class="font-table">{{
                            findNoiniciados(scope.row.contratos).length
                          }}</span>
                        </b>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" align="center" label="REVISIÓN">
                    <template slot-scope="scope">
                      <el-button
                        v-if="scope.row"
                        :disabled="
                          findRevision(scope.row.contratos).length === 0
                        "
                        style="width: 100%"
                        plain
                        @click="
                          openDialogContrato(findRevision(scope.row.contratos))
                        "
                      >
                        <b>
                          <span class="font-table">{{
                            findRevision(scope.row.contratos).length
                          }}</span>
                        </b>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="N° de Riesgos en Revisión"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-if="scope.row"
                        :disabled="scope.row.riesgos.length === 0"
                        style="width: 100%"
                        plain
                        @click="openDialogRiesgos(scope.row.riesgos)"
                      >
                        <b>
                          <span class="font-table">{{
                            scope.row.riesgos.length
                          }}</span>
                        </b>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="N° Riesgos Pendientes de revisión con más de 10 dias"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-if="scope.row"
                        :disabled="mayoresdies(scope.row.riesgos).length === 0"
                        style="width: 100%"
                        plain
                        @click="
                          openDialogRiesgos(mayoresdies(scope.row.riesgos))
                        "
                      >
                        <b>
                          <span class="font-table">{{
                            mayoresdies(scope.row.riesgos).length
                          }}</span>
                        </b>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="Tiempo promedio de retraso en riesgos con más de 10 días."
                  >
                    <template slot-scope="scope">
                      <b>
                        <span class="font-table">{{
                          promediodias(scope.row.riesgos)
                        }}</span>
                      </b>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable prop="nombre" label="Nombre">
          <template slot-scope="scope">
            <b>
              <span class="font-table">{{ scope.row.nombre }}</span>
            </b>
          </template>
        </el-table-column>
        <el-table-column width="170" align="center" label="TOTAL INVENTARIOS">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row"
              :disabled="scope.row.contratos.length === 0"
              style="width: 100%"
              plain
              @click="openDialogContrato(scope.row.contratos)"
            >
              <b>
                <span class="font-table">{{ total(scope.row.contratos) }}</span>
              </b>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center" label="APROBADOS">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row"
              :disabled="findAprobados(scope.row.contratos).length === 0"
              style="width: 100%"
              plain
              @click="openDialogContrato(findAprobados(scope.row.contratos))"
            >
              <b>
                <span class="font-table">{{
                  findAprobados(scope.row.contratos).length
                }}</span>
              </b>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center" label="BORRADOR">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row"
              :disabled="findBorrador(scope.row.contratos).length === 0"
              style="width: 100%"
              plain
              @click="openDialogContrato(findBorrador(scope.row.contratos))"
            >
              <b>
                <span class="font-table">{{
                  findBorrador(scope.row.contratos).length
                }}</span>
              </b>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center" label="NO INICIADOS">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row"
              :disabled="findNoiniciados(scope.row.contratos).length === 0"
              style="width: 100%"
              plain
              @click="openDialogContrato(findNoiniciados(scope.row.contratos))"
            >
              <b>
                <span class="font-table">{{
                  findNoiniciados(scope.row.contratos).length
                }}</span>
              </b>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center" label="REVISIÓN">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row"
              :disabled="findRevision(scope.row.contratos).length === 0"
              style="width: 100%"
              plain
              @click="openDialogContrato(findRevision(scope.row.contratos))"
            >
              <b>
                <span class="font-table">{{
                  findRevision(scope.row.contratos).length
                }}</span>
              </b>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="N° de Riesgos en Revisión"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row"
              :disabled="scope.row.riesgos.length === 0"
              style="width: 100%"
              plain
              @click="openDialogRiesgos(scope.row.riesgos)"
            >
              <b>
                <span class="font-table">{{ scope.row.riesgos.length }}</span>
              </b>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="N° Riesgos Pendientes de revisión con más de 10 dias"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row"
              :disabled="mayoresdies(scope.row.riesgos).length === 0"
              style="width: 100%"
              plain
              @click="openDialogRiesgos(mayoresdies(scope.row.riesgos))"
            >
              <b>
                <span class="font-table">{{
                  mayoresdies(scope.row.riesgos).length
                }}</span>
              </b>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="Tiempo promedio de retraso en riesgos con más de 10 días."
        >
          <template slot-scope="scope">
            <b>
              <span class="font-table">{{
                promediodias(scope.row.riesgos)
              }}</span>
            </b>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <el-dialog
      top="30px"
      title="Listado de contratos"
      :visible.sync="dialogContratos"
      width="80%"
      :before-close="handleClose"
    >
      <center v-if="loading">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>Cargando Datos ...</small>
        <br />
        <br />
      </center>

      <el-form v-if="!loading" onsubmit="return false;">
        <el-form-item label="Búsqueda por nombre del contrato">
          <el-input
            placeholder="Ingrese su texto de búsqueda aquí"
            size="small"
            icon="el-icon-search"
            v-model="search_contract"
          ></el-input>
        </el-form-item>
      </el-form>

      <el-table
        v-if="!loading"
        :key="search_contract"
        height="400"
        :data="
          paginate(
            contratos.filter(
              (data) =>
                !search_contract ||
                data.nombre
                  .toLowerCase()
                  .includes(search_contract.toLowerCase())
            ),
            6,
            page_contract
          )
        "
        border
        style="width: 100%; font-size: 13px;"
        header-cell-class-name="header-blue-light"
      >
        <el-table-column prop="nombre" label="Nombre"></el-table-column>
        <el-table-column
          width="180"
          prop="tipo_contrato"
          label="Tipo de contrato"
        ></el-table-column>
        <el-table-column label="Área" prop="nombre_area"></el-table-column>
        <el-table-column width="230" label="Estado">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row['wasApproved']">{{
              status[2]
            }}</el-tag>
            <el-tag v-else :type="type_tag[scope.row.status]">{{
              status[scope.row.status]
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Opciones">
          <template slot-scope="scope">
            <div v-if="scope.row.status !== 'undefined'">
              <el-button
                style="margin-top: 5px; margin-bottom: 5px"
                size="small"
                @click="openDialogView(scope.row._id)"
                >Visualizar</el-button
              >
              <el-button
                style="margin-top: 5px; margin-bottom: 5px"
                type="danger"
                size="small"
                @click="downloadPDF(scope.row.id_inventario)"
                >Descargar PDF</el-button
              >
            </div>
            <el-tag v-else type="danger">NO DISPONIBLE</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="90" align="center">
          <template slot-scope="scope">
            <el-button
              style="color: green; font-weight: bold"
              type="text"
              size="medium"
              @click="descargarExcel(scope.row._id)"
              ><img
                width="30px"
                src="https://icons.iconarchive.com/icons/dakirby309/simply-styled/128/Microsoft-Excel-2013-icon.png"
                alt=""
              /><br />
              <small>Descargar</small></el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <center :class="{ 'display-none': loading }">
        <el-pagination
          style="margin-top: 40px"
          :current-page="page_contract"
          @prev-click="backPageContract"
          @next-click="nextPageContract"
          @current-change="currentPageContract"
          :page-size="6"
          layout="prev, pager, next"
          :total="
            contratos.filter(
              (data) =>
                !search_contract ||
                data.nombre
                  .toLowerCase()
                  .includes(search_contract.toLowerCase())
            ).length
          "
        ></el-pagination>
      </center>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      top="30px"
      title="Listado de riesgos"
      :visible.sync="dialogRiesgos"
      width="90%"
      :before-close="handleClose"
    >
      <el-form onsubmit="return false;" label-position="top">
        <el-row :gutter="20">
          <el-col :md="20">
            <el-form-item
              label="Búsqueda por nombre del inventario, área o riesgo."
            >
              <el-input
                size="medium"
                icon="el-icon-search"
                placeholder="Ingrese su texto de búsqueda aquí"
                v-model="search_contract"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="4">
            <el-form-item label="Descargar Reporte.">
              <el-button
                @click="getPDF(riesgos)"
                icon="el-icon-download"
                style="background-color: green; color: white"
                size="medium"
                >Descargar XLS</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table
        :key="search_contract"
        height="400"
        :data="
          paginate(
            riesgos.filter(
              (data) =>
                !search_contract ||
                data.inventario
                  .toLowerCase()
                  .includes(search_contract.toLowerCase()) ||
                data.nombre_area
                  .toLowerCase()
                  .includes(search_contract.toLowerCase()) ||
                data.riesgo
                  .toLowerCase()
                  .includes(search_contract.toLowerCase())
            ),
            6,
            page_risks
          )
        "
        border
        style="width: 100%"
        header-cell-class-name="header-blue-light"
      >
        <el-table-column prop="inventario" label="Inventario"></el-table-column>
        <el-table-column prop="nombre_area" label="Área"></el-table-column>
        <el-table-column prop="tarea" label="Tarea"></el-table-column>
        <el-table-column prop="riesgo" label="Riesgo"></el-table-column>
        <el-table-column label="Roles Evaluadores">
          <template slot-scope="scope">
            <ul>
              <li
                type="square"
                v-for="(item, index) in scope.row.rol_revisor"
                :key="index"
              >
                {{ reviewerRoles[item] }}
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column label="Usuarios Evaluadores">
          <template slot-scope="scope">
            <ul>
              <li
                type="square"
                v-for="(item, index) in scope.row.revisor"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="150"
          prop="dias"
          label="Días de atraso"
          sortable
        ></el-table-column>
      </el-table>

      <center>
        <el-pagination
          style="margin-top: 40px"
          :current-page="page_risks"
          @prev-click="backPageRisk"
          @next-click="nextPageRisk"
          @current-change="currentPageRisk"
          :page-size="6"
          layout="prev, pager, next"
          :total="
            riesgos.filter(
              (data) =>
                !search_contract ||
                data.inventario
                  .toLowerCase()
                  .includes(search_contract.toLowerCase()) ||
                data.nombre_area
                  .toLowerCase()
                  .includes(search_contract.toLowerCase()) ||
                data.riesgo
                  .toLowerCase()
                  .includes(search_contract.toLowerCase())
            ).length
          "
        ></el-pagination>
      </center>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Visualizar Inventario"
      :visible.sync="dialogView"
      top="30px"
      width="80%"
      append-to-body
    >
      <center v-if="loading">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>Cargando Datos ...</small>
        <br />
        <br />
      </center>
      <div v-else>
        <el-row :gutter="30">
          <el-col :md="12">
            <h4>Nombre del contrato</h4>
            {{ contrato.nombre || "---" }}
          </el-col>
          <el-col v-if="area" :md="12">
            <h4>Área</h4>
            {{ area.nombre || "---" }}
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col
            v-if="empresa && contrato.tipo_contrato === 'Contratista'"
            :md="12"
          >
            <h4>Empresa</h4>
            {{ empresa.nombre || "---" }}
          </el-col>
          <el-col :md="12">
            <h4>Fecha de creación</h4>
            {{
              inventario.created_at
                ? getHumanDate(inventario.created_at).toUpperCase()
                : "---"
            }}
          </el-col>
          <el-col :md="4">
            <h4>Estado del Inventario</h4>
            <el-tag :type="type_tag[inventario.status]">{{
              status[getNameStatus(inventario)]
            }}</el-tag>
          </el-col>
        </el-row>
        <br />
        <hr />
        <div class="hidden-sm-and-down table-inventory">
          <h4>Seleccione alguna tarea para desplegar más información</h4>
          <br />
          <el-collapse>
            <el-collapse-item
              v-for="(tarea, index) in inventario.tareas"
              :key="tarea.id || tarea._id"
            >
              <template slot="title">
                <div>
                  <span class="titleCollapseTask">{{
                    shortStr(tarea.nombre)
                  }}</span>
                  <span v-if="tarea.riesgos" class="custom-tag n-risks"
                    >{{ tarea.riesgos.length }} riesgos</span
                  >
                </div>
              </template>
              <div v-if="tarea.procedimiento">
                <div style="margin-top: 10px;"><b>PROCEDIMIENTO</b></div>
                <p style="margin-top: 10px; margin-bottom: 30px;">{{ tarea.procedimiento }}</p>
              </div>
              <el-table
                :max-height="700"
                :data="inventario.tareas[index].riesgos"
                header-cell-class-name="header-cell-class-table-gray"
                empty-text="Sin riesgos registrados"
                row-class-name="rowClassTablaPloma"
                :cell-class-name="pintarTipo"
              >
                <el-table-column
                  type="expand"
                  width="40"
                  label="+"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div
                      style="
                        padding-left: 30px;
                        padding-right: 30px;
                        padding-bottom: 20px;
                      "
                    >
                      <el-row>
                        <el-col :span="8">
                          <h4>Causas</h4>
                          <ol>
                            <li
                              v-for="(item, index) in scope.row.causas"
                              :key="index"
                            >
                              {{ item.nombre }}
                            </li>
                          </ol>
                        </el-col>
                        <el-col :span="8">
                          <h4>Controles Preventivos</h4>
                          <ol>
                            <li
                              v-for="(control, i) in getControlesPreventivos(
                                scope.row
                              )"
                              :key="i"
                              :class="{ fontRed: control.critico }"
                            >
                              {{ control.nombre }}
                            </li>
                          </ol>
                        </el-col>
                        <el-col :span="8">
                          <h4>Controles Mitigadores</h4>
                          <ol>
                            <li
                              v-for="(control, i) in getControlesMitigadores(
                                scope.row
                              )"
                              :key="i"
                            >
                              {{ control.nombre }}
                            </li>
                          </ol>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="nombre" label="Nombre" />
                <el-table-column width="150" align="center" label="Impacto">
                  <template slot-scope="scope">{{
                    getMayorImpacto(scope.row).mfl
                  }}</template>
                </el-table-column>
                <el-table-column width="150" align="center" label="MFL">
                  <template slot-scope="scope">
                    <el-tag
                      :type="mflRange(getMayorImpacto(scope.row).mfl)"
                      class="big"
                      >{{ getMayorImpacto(scope.row).mfl }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column width="150" align="center" label="FS">
                  <template slot-scope="scope">{{
                    getMayorImpacto(scope.row).impacto &&
                    getMayorImpacto(scope.row).impacto.factor_severidad
                  }}</template>
                </el-table-column>
                <el-table-column width="150" align="center" label="FP">
                  <template slot-scope="scope">{{
                    getMayorImpacto(scope.row).impacto &&
                    getMayorImpacto(scope.row).impacto.factor_probabilidad
                  }}</template>
                </el-table-column>
                <el-table-column width="150" align="center" label="RRR">
                  <template slot-scope="scope">
                    <el-tag class="big" type="info">{{
                      getMayorImpacto(scope.row).rrr
                    }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column width="150" align="center" label="NSR">
                  <template slot-scope="scope">{{
                    getMayorImpacto(scope.row).impacto &&
                    getMayorImpacto(scope.row).impacto.nivel_severidad
                  }}</template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="!loading"
          type="danger"
          @click="downloadPDF(inventario._id)"
          >Descargar</el-button
        >
        <el-button @click="closeViewInventory">Cancelar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import axios from "axios";
import moment from "moment";

export default {
  props: ["data", "tiempo"],
  data() {
    return {
      json_fields: {
        "Nombre del Inventario": "inventario",
        "Nombre del Área": "nombre_area",
        "Nombre de la Tarea": "tarea",
        "Nombre del Riesgo": "riesgo",
        "Usuarios Evaluadores": "revisor",
        "Días Acumulados": "dias",
        "Roles Evaluadores": {
          field: "rol_revisor",
          callback: (value) => {
            var roles = [];
            value.forEach((r) => {
              roles.push(this.reviewerRoles[r]);
            });
            return roles;
          },
        },
      },
      reviewerRoles: {
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_coordinator: "Coordinador Contratista",
        coordinator: "Coordinador",
        contractor_hse: "HSE Contratista",
        contract_owner: "Dueño de Contrato",
        administrator: "Administrador de Contrato",
        hse: "HSE",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
      },
      search_contract: "",
      text_msj: "",
      loading: false,
      type_tag: {
        "-2": "danger",
        undefined: "info",
        0: "info",
        1: "warning",
        2: "success",
        3: "info",
        4: "warning",
      },
      status: {
        "-2": "SIN ESTADO",
        undefined: "NO INICIADO",
        0: "BORRADOR",
        1: "EN REVISIÓN",
        2: "APROBADO",
        3: "IMPORTADO BORRADOR",
        4: "REVISIÓN DE MEDIOAMBIENTE",
        5: "APROBADO EN ACTUALIZACIÓN",
      },
      page_risks: 1,
      page_contract: 1,
      dialogView: false,
      dialogContratos: false,
      dialogRiesgos: false,
      contratos: [],
      riesgos: [],
      /* DATA INVENTARIO */
      inventario: {},
      contrato: {},
      empresa: {},
      area: {},
    };
  },
  watch: {
    search_contract(newVal, oldVal) {
      this.page_contract = 1;
      this.page_risks = 1;
    },
  },
  components: {
    Circle9,
  },
  methods: {
    getNameStatus(inventario) {
      if (inventario && [1, "1"].includes(inventario.status) && inventario.wasApproved === true) {
        return 5;
      } else {
        return inventario.status;
      }
    },
    descargarExcel(id) {
      window.location.href = `https://bhp.lifeon.cl/data-science/reportes/getInventory/${id}`;
    },
    getPDF(riesgos) {
      var xlsx = require("json-as-xlsx");

      var columns = [
        { label: "Nombre del Inventario", value: "inventario" }, // Top level data
        { label: "Nombre del Área", value: "nombre_area" },
        { label: "Nombre de la Tarea", value: "tarea" },
        { label: "Nombre del Riesgo", value: "riesgo" },
        {
          label: "Usuarios Evaluadores",
          value: (row) => row.revisor.toString(),
        }, // Run functions
        { label: "Días Acumulados", value: "dias" },
        {
          label: "Roles Evaluadores",
          value: (row) => {
            var roles = [];
            row.rol_revisor.forEach((r) => {
              roles.push(this.reviewerRoles[r]);
            });
            return roles.toString();
          },
        }, // Run functions
      ];

      var content = riesgos;

      var settings = {
        sheetName: "Riesgos Pendientes", // The name of the sheet
        fileName: "Planilla Riesgos Pendientes", // The name of the spreadsheet
        extraLength: 3, // A bigger number means that columns should be wider
      };

      var download = true; // If true will download the xlsx file, otherwise will return a buffer

      xlsx(columns, content, settings, download); // Will download the excel file
    },
    closeViewInventory() {
      this.dialogView = false;
      this.loading = false;
    },
    currentPageRisk(page) {
      this.page_risks = page;
      this.paginate(this.riesgos, 6, this.page_risks);
    },
    nextPageRisk(page) {
      this.page_risks = page;
      this.paginate(this.riesgos, 6, this.page_risks);
    },
    backPageRisk(page) {
      this.page_risks = page;
      this.paginate(this.riesgos, 6, this.page_risks);
    },
    currentPageContract(page) {
      this.page_contract = page;
      this.paginate(this.contratos, 6, this.page_contract);
    },
    nextPageContract(page) {
      this.page_contract = page;
      this.paginate(this.contratos, 6, this.page_contract);
    },
    backPageContract(page) {
      this.page_contract = page;
      this.paginate(this.contratos, 6, this.page_contract);
    },
    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },
    getHumanDate(date) {
      return moment(date).format("DD MMMM YYYY HH:mm");
    },
    async downloadPDF(id) {
      this.text_msj = "Descargando PDF ...";
      this.loading = true;
      this.$store.dispatch("getPDF", id).then(() => {
        this.loading = false;
      });
    },
    async openDialogView(id) {
      await this.getInventory(id);
      this.dialogView = true;
    },
    async getInventory(contrato_id) {
      this.text_msj = "Obteniendo Inventario ...";
      this.loading = true;
      const self = this;
      await axios
        .get(`/data-science/contratos/${contrato_id}/full`)
        .then((response) => {
          self.inventario = response.data.inventario;
          self.contrato = response.data.contrato;
          self.empresa = response.data.empresa;
          self.area = response.data.area;
          self.loading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    openDialogContrato(contratos) {
      this.dialogContratos = true;
      this.contratos = contratos;
    },
    openDialogRiesgos(riesgos) {
      this.dialogRiesgos = true;
      this.riesgos = riesgos;
    },
    handleClose() {
      this.dialogContratos = false;
      this.dialogRiesgos = false;
      this.contratos = [];
      this.riesgos = [];
      this.search_contract = "";
      this.page_contract = 1;
      this.page_risks = 1;
    },
    shortStr(nombre) {
      return nombre.length > 200 ? `${nombre.substr(0, 200)}...` : nombre;
    },
    promediodias(riesgos) {
      var lista = riesgos.filter(function (el) {
        return el.dias > 10;
      });
      const dias = lista.map((r) => r.dias);
      const total = dias.reduce((a, b) => a + b, 0);
      if (total === 0) {
        return 0;
      }
      const promedio = total / lista.length;
      const redondeado = Math.round(promedio);
      return redondeado;
    },
    mayoresdies(riesgos) {
      return riesgos.filter((el) => el.dias > 10);
    },
    total(contratos) {
      return (
        this.findAprobados(contratos).length +
        this.findBorrador(contratos).length +
        this.findRevision(contratos).length +
        this.findNoiniciados(contratos).length
      );
    },
    findAprobados(contratos) {
      return contratos.filter(
        (el) => ["2", 2].includes(el.status) || el.wasApproved === true
      );
    },
    findBorrador(contratos) {
      return contratos.filter(
        (el) =>
          ["0", 0, "3", 3].includes(el.status) &&
          (!el.hasOwnProperty("wasApproved") || el.wasApproved === false)
      );
    },
    findRevision(contratos) {
      return contratos.filter(
        (el) =>
          ["1", 1, "4", 4].includes(el.status) &&
          (!el.hasOwnProperty("wasApproved") || el.wasApproved === false)
      );
    },
    findNoiniciados(contratos) {
      return contratos.filter((el) => el.status === "undefined");
    },
    pintarTipo({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTablaPloma ";
      if (columnIndex === 0) {
        if (row.tipo.toLowerCase() === "seguridad") {
          classes += "colorSeguridad";
        } else if (row.tipo.toLowerCase() === "salud") {
          classes += "colorSalud";
        } else if (
          row.tipo.toLowerCase() === "salud y seguridad" &&
          !row.custom
        ) {
          classes += "colorSaludySeguridad";
        } else if (row.tipo.toLowerCase() === "medioambiente") {
          classes += "colorMedioambiente";
        } else {
          classes += "sinTipo";
        }
      }
      return classes;
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "";
      if (columnIndex === 0) {
        classes = "colorCellDashboard";
      }
      return classes;
    },
    pintar_gerencias({ row, column, rowIndex, columnIndex }) {
      let classes = "";
      if (columnIndex === 0) {
        classes = "colorCellDashboard5";
      }
      return classes;
    },
    pintar_superintendencia({ row, column, rowIndex, columnIndex }) {
      let classes = "";
      if (columnIndex === 0) {
        classes = "colorCellDashboard2";
      }
      return classes;
    },
    pintar_areas({ row, column, rowIndex, columnIndex }) {
      let classes = "";
      if (columnIndex === 0) {
        classes = "colorCellDashboard3";
      }
      return classes;
    },
    pintar_subareas({ row, column, rowIndex, columnIndex }) {
      let classes = "";
      if (columnIndex === 0) {
        // classes = "colorCellDashboard4";
        classes = "";
      }
      return classes;
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map((key) => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id,
      }));
      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "info";
    },
  },
};
</script>

<style scoped>
.display-none {
  display: none;
}
.font-table {
  font-size: 14px;
}
.titleCollapseTask {
  font-size: 13px;
  min-width: 150px;
  padding-right: 20px;
  padding-right: 20px;
  height: 60px;
}
.custom-tag {
  padding: 0 10px;
  height: 38px;
  line-height: 38px;
  margin: 0 5px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.custom-tag.n-risks {
  background-color: rgba(103, 194, 58, 0.1);
  border-color: rgba(103, 194, 58, 0.2);
  color: #67c23a;
}
</style>
